
export class CareModel {
   customerName: string;
   customerEmail: string;
   agentUserId: string;
   fanList: Array<FanModel>;
   selectedFan: FanModel;
   selectedDevice: string;
   selectedLaunchMode: string;
   searchFan: number;
   showResetOption: boolean;
   tcmAopEmailAddress: any;
   showEdit: boolean;

   constructor() {
     this.customerName = '';
     this.customerEmail = '';
     this.agentUserId = '';
     this.selectedLaunchMode = '';
     this.searchFan = null;
     this.fanList = [];
     this.tcmAopEmailAddress = [];
     this.showEdit = false;
   }
}


export class FanModel {
    fanId: number;
    status: string; // Active, Enrolled not active, In Progress
    profile: number; // ProfileModel profileId
    selected?: boolean;
}

export class SelectedFan {
   ctnNumber: string;
   model: string;
   status: string;
   userName: string;
   constructor() {
     this.ctnNumber = '';
     this.model = '';
     this.status = '';
     this.userName = '';
   }
}
